import type {
  FreeTextQuestion,
  MultipleChoiceQuestion,
  SingleChoiceQuestion,
} from 'src/__generated__/graphql';

export type Question =
  | SingleChoiceQuestion
  | MultipleChoiceQuestion
  | FreeTextQuestion;

export function isFreeTextQuestion(
  question: any,
): question is FreeTextQuestion {
  return question.__typename === 'FreeTextQuestion';
}

export function isSingleChoiceQuestion(
  question: any,
): question is SingleChoiceQuestion {
  return question.__typename === 'SingleChoiceQuestion';
}

export function isMultipleChoiceQuestion(
  question: any,
): question is MultipleChoiceQuestion {
  return question.__typename === 'MultipleChoiceQuestion';
}

export function questionIdToFieldKey(id: string) {
  return id.replace(/,/g, '__comma__');
}
